/** Injected from package.json at build time (see vue.config.js). */
export const APP_VERSION = process.env.VUE_APP_VERSION || '0.6.0';

/** User-facing label, e.g. "0.6" from semver "0.6.0". */
export function formatAppVersionLabel(version = APP_VERSION) {
  const normalized = String(version).trim();
  if (!normalized) return '0.6';

  const parts = normalized.split('.');
  if (parts.length >= 2 && (parts[2] === '0' || parts[2] === '')) {
    return `${parts[0]}.${parts[1]}`;
  }

  return normalized;
}
